import React from 'react';
import { Column, Table, PageBar, Loading } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';
import { isMainAccount, bindStatus, isNormalAccount } from '../../../consts/multiAccountConfig';
import { OPERATION_TYPE } from './config';

import useTable from '../../../leads_component/shared-components/hooks/useAsyncTable';
import useConfirm from '../../../leads_component/shared-components/hooks/useContentDialog';
import useFeedback from '../../../leads_component/shared-components/hooks/useFeedback';

import FeedBackDialog from '../../common/feedback';
import Confirm from './confirmDialog';

const Page = () => {
  const [target, setTarget] = React.useState(null);
  const confirmDialogHooks = useConfirm({ showDialog: false });
  const feedbackHooks = useFeedback();
  const tableHooks = useTable({
    deps: [],
    getList: (setTableData, setTotal, curPage, pageSize) => {
      if (isMainAccount()) {
        const promise = Promise.resolve();
        return promise;
      }
      return RPCFactory.multiaccount
        .getAuthList({
          pageIndex: curPage,
          pageSize,
        })
        .done((data) => {
          setTableData(data.entities);
          setTotal(data.size);
        })
        .fail((status, msg) => {
          feedbackHooks.showErrorTip(msg ? msg : '请求失败');
        });
    },
  });

  const renderID = (type, name, value, row) => {
    if (type == 'data') {
      if (row.mainWeChatAppId && row.mainWeChatAppId != '') {
        return row.mainWeChatAppId;
      }
      return row.mainAccountId;
    }
    return value;
  };
  const handleClick = (e, type, row) => {
    setTarget(e.target);
    confirmDialogHooks.openDialog({ type, row });
  };

  const renderStatus = (type, name, value, row) => {
    if (type == 'data') {
      if (value == bindStatus.binded) {
        return (
          <div>
            <span>已绑定</span>
            <a
              className="a-link-primary"
              onClick={(e) => {
                handleClick(e, OPERATION_TYPE.unbindAccount, row);
              }}
            >
              撤销授权
            </a>
          </div>
        );
      }
      if (value == bindStatus.canceling) {
        return (
          <div>
            <span>撤销中</span>
            <a
              className="a-link-primary"
              onClick={(e) => {
                handleClick(e, OPERATION_TYPE.withdrawUnbind, row);
              }}
            >
              继续授权
            </a>
          </div>
        );
      }
      if (value == bindStatus['pre-bind']) {
        return (
          <div>
            <span>待确认授权</span>
            <a
              className="a-link-primary"
              onClick={(e) => {
                handleClick(e, OPERATION_TYPE.confirmBind, row);
              }}
            >
              确认授权
            </a>
            <a
              className="a-link-primary"
              onClick={(e) => {
                handleClick(e, OPERATION_TYPE.denyBind, row);
              }}
            >
              拒绝授权
            </a>
          </div>
        );
      }
      return <div></div>;
    }
    return value;
  };

  const renderAuthTable = () => (
    <div className="datarea" id="datarea">
      <div className="toolbars">
        <h4>授权数据</h4>
        {isNormalAccount() ? (
          <p className="toolbar-tips">您仅可以选择一个账号进行授权，选择后其它账号授权状态自动变更为“已拒绝”。</p>
        ) : null}
      </div>
      <div className="datalist">
        <Table data={tableHooks.data}>
          <Column name="mainAccountId" render={renderID}>
            账号ID
          </Column>
          <Column name="mainAccountName">主体名称</Column>
          <Column name="bindStatus" className="tb-action" render={renderStatus}>
            授权状态
          </Column>
        </Table>
      </div>
      <PageBar {...tableHooks.pageBarAttr} />
      <FeedBackDialog {...feedbackHooks} />
      {confirmDialogHooks.show ? (
        <Confirm
          {...confirmDialogHooks}
          target={target}
          onSubmit={() => {
            confirmDialogHooks.onSubmit();
            tableHooks.reloadTable();
          }}
          feedbackHooks={feedbackHooks}
        />
      ) : null}
      {tableHooks.tableLoading ? <Loading /> : null}
    </div>
  );
  const renderEmpty = () => (
    <div className="empty">
      <span className="empty-icon"></span>
      <span className="empty-des">您还没有授权内容</span>
    </div>
  );
  const Elmt =!isMainAccount() && !tableHooks.tableLoading && tableHooks.pageBarAttr.totalSize != 0
    ? renderAuthTable()
    : renderEmpty();
  return (
    <div className="onlycard">
      <div className="card">
        { Elmt }
      </div>
    </div>
  );
};

export default Page;
